// BrainForge Navbar with Live Unit Counter
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiUrl } from '../config/api';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [unitsBalance, setUnitsBalance] = useState(user?.units_balance || 0);
  const [animateUnits, setAnimateUnits] = useState(false);

  useEffect(() => {
    if (user) {
      loadBalance();
    }
  }, [user]);

  useEffect(() => {
    const handleUnitUpdate = (e) => {
      if (e.detail?.unitsBalance !== undefined) {
        setUnitsBalance(prev => {
          if (e.detail.unitsBalance < prev) {
            setAnimateUnits(true);
            setTimeout(() => setAnimateUnits(false), 500);
          }
          return e.detail.unitsBalance;
        });
      }
    };
    window.addEventListener('unitUpdate', handleUnitUpdate);
    return () => window.removeEventListener('unitUpdate', handleUnitUpdate);
  }, []);

  const loadBalance = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(apiUrl('/api/units/balance'), {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.balance !== undefined) setUnitsBalance(data.balance);
    } catch (e) {}
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const getUnitColor = () => {
    if (unitsBalance <= 0) return '#ef4444';
    if (unitsBalance <= 3) return '#f59e0b';
    if (unitsBalance <= 5) return '#eab308';
    return '#22c55e';
  };

  return (
    <nav style={{
      background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.95), rgba(30, 41, 59, 0.95))',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(255,255,255,0.1)',
      padding: '12px 24px',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Link to={user ? '/dashboard' : '/'} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          textDecoration: 'none'
        }}>
          <span style={{ fontSize: '28px' }}>🧠</span>
          <span style={{
            fontSize: '22px',
            fontWeight: '700',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            BrainForge
          </span>
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          {user ? (
            <>
              <div 
                onClick={() => navigate('/dashboard?showPurchase=true')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 16px',
                  background: `${getUnitColor()}15`,
                  border: `2px solid ${getUnitColor()}`,
                  borderRadius: '12px',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  transform: animateUnits ? 'scale(1.1)' : 'scale(1)'
                }}
              >
                <span style={{ fontSize: '18px' }}>🪙</span>
                <span style={{
                  color: getUnitColor(),
                  fontWeight: '700',
                  fontSize: '16px',
                  transition: 'all 0.3s'
                }}>
                  {unitsBalance}
                </span>
                <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px' }}>units</span>
              </div>

              <Link to="/dashboard" style={{
                color: location.pathname === '/dashboard' ? '#667eea' : 'rgba(255,255,255,0.7)',
                textDecoration: 'none',
                fontWeight: '500',
                fontSize: '14px'
              }}>Dashboard</Link>

              <Link to="/settings" style={{
                color: location.pathname === '/settings' ? '#667eea' : 'rgba(255,255,255,0.7)',
                textDecoration: 'none',
                fontWeight: '500',
                fontSize: '14px'
              }}>Settings</Link>

              <button onClick={handleLogout} style={{
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '8px',
                padding: '8px 16px',
                color: 'rgba(255,255,255,0.8)',
                fontSize: '14px',
                cursor: 'pointer'
              }}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/pricing" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontWeight: '500', fontSize: '14px' }}>Pricing</Link>
              <Link to="/login" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontWeight: '500', fontSize: '14px' }}>Login</Link>
              <Link to="/signup" style={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                padding: '10px 20px',
                borderRadius: '8px',
                color: 'white',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '14px'
              }}>Start Free</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
